import NoSSR from './NoSSR';

export default NoSSR;
